export default __webpack_public_path__ + "static/media/striker-circle.18cac32f.svg";